import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import CarClass from '../../../../../types/car-class/CarClass';
import CarClassWriteDTO from '../../../../../types/car-class/CarClassWriteDTO';
import { IsAdminDirective } from '../../../directives/is-admin.directive';
import { RoleNamePipe } from '../../../pipes/role-name.pipe';
import { CarClassService } from '../../../services/car-class.service';
import {
    UpdateCarClassDialogComponent
} from '../../shared/car-classes/update-car-class-dialog/update-car-class-dialog.component';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';

@Component({
    selector: 'app-car-class-detail',
    templateUrl: './car-class-detail.component.html',
    styleUrls: [ './car-class-detail.component.scss' ],
    imports: [
        Button,
        RouterLink,
        PageHeaderComponent,
        UpdateCarClassDialogComponent,
        RoleNamePipe,
        IsAdminDirective
    ]
})
export class CarClassDetailComponent implements OnInit {
    public carClass: CarClass | null = null;
    public editableCarClass: CarClassWriteDTO = new CarClassWriteDTO({});
    public displayUpdateDialog = false;

    constructor(
        private route: ActivatedRoute,
        private carClassService: CarClassService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService
    ) {
    }

    /**
     * Initializes the component.
     */
    public ngOnInit(): void {
        this.loadCarClass();
    }

    /**
     * Opens the edit dialog.
     */
    public openEditDialog(): void {
        this.editableCarClass = new CarClassWriteDTO(this.carClass ?? {});
        this.displayUpdateDialog = true;
    }

    /**
     * Reloads the car class details.
     */
    public reloadCarClassDetails(): void {
        this.loadCarClass();
    }

    /**
     * Confirms the deletion of the car class.
     */
    public confirmDelete(): void {
        if (!this.carClass) {
            return;
        }

        this.confirmationService.confirm({
            message: `Are you sure you want to delete the car class '${ this.carClass.name }'?`,
            header: 'Confirm Deletion',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                if (!this.carClass) {
                    return;
                }
                this.carClassService.deleteCarClass(this.carClass.id).then(() => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Deleted',
                        detail: 'Car class deleted successfully',
                        life: 3000
                    });
                    // Navigate back to the car classes page
                    window.history.back();
                }).catch((error: any) => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
                });
            }
        });
    }

    /**
     * Loads the car class.
     */
    private loadCarClass(): void {
        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            const idNumber = parseInt(id, 10);
            this.carClassService.getCarClass(idNumber).then((result: CarClass) => {
                this.carClass = result;
            }).catch((error: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            });
        }
    }
}
